import { ActionReducerMap, createReducer, on } from '@ngrx/store';

import { affiliateReducer } from '../../modules/affiliates/state/affiliate.reducer';
import { placeBetReducer } from '../../modules/betplacement/reducer/place-bet.reducer';
import { placeButtonReducer } from '../../modules/betplacement/reducer/place-button.reducer';
import { hiddenMarketReducer } from '../../modules/hidden-market/reducer/hidden-market.reducer';
import { infoMessagesReducer } from '../../modules/info-messages/reducer';
import { lineSwitcherReducer } from '../../modules/line-switcher/reducer';
import { notificationStateReducer } from '../../modules/notifications/reducer';
import { oddsPreferencePopupReducer } from '../../modules/odds-preference-popup/reducer';
import { overAskReducer } from '../../modules/over-ask/reducer';
import { picksReducer } from '../../modules/picks/reducer';
import { quickBetReducer } from '../../modules/quick-bet/quick-bet.reducer';
import { quickDepositStateReducer } from '../../modules/quick-deposit/quick-deposit.reducer';
import { resultReducer } from '../../modules/result/reducer';
import { rewardTokensReducer } from '../../modules/reward-tokens/reducer';
import { settingsReducer } from '../../modules/settings/reducer';
import { sourcePageStateReducer } from '../../modules/source-page/reducer/source-page.reducer';
import { trackingReducer } from '../../modules/tracking/reducer';
import { typesReducer } from '../../modules/types/reducer';
import { errorReducer } from '../../modules/validation/reducer';
import BetslipActions from './actions';
import { ModalActions } from './modal-action';
import { IBetslipBaseState, IBetslipState, defaultBetslipBaseState } from './state';

const baseReducer = createReducer<IBetslipBaseState>(
    defaultBetslipBaseState,
    on(BetslipActions.setState, (state, action): IBetslipBaseState => {
        return {
            ...state,
            state: action.state,
        };
    }),
    on(ModalActions.updateKeypadState, (state, action): IBetslipBaseState => {
        return {
            ...state,
            isBetslipKeypadOpened: action.isOpen,
        };
    }),
    on(BetslipActions.toggleBetslipDisplayMode, (state, action): IBetslipBaseState => {
        return {
            ...state,
            displayMode: action.mode,
        };
    }),
);

export const betslipRootReducer: ActionReducerMap<IBetslipState> = {
    base: baseReducer,
    picks: picksReducer,
    types: typesReducer,
    errors: errorReducer,
    rewardTokens: rewardTokensReducer,
    placeBet: placeBetReducer,
    result: resultReducer,
    settings: settingsReducer,
    placeButton: placeButtonReducer,
    overAskState: overAskReducer,
    lineSwitcher: lineSwitcherReducer,
    notifications: notificationStateReducer,
    affiliateState: affiliateReducer,
    quickBet: quickBetReducer,
    quickDeposit: quickDepositStateReducer,
    hiddenMarket: hiddenMarketReducer,
    oddsPreferencePopupState: oddsPreferencePopupReducer,
    sourcePageState: sourcePageStateReducer,
    infoMessages: infoMessagesReducer,
    tracking: trackingReducer,
};
